import styled from "styled-components"
import {Title} from '../assets/styles/commonStyles'

const MyWorkContainer = styled.div`
  padding:30px;

  @media screen and (max-width: 768px){
    padding: 30px 5px;
  }

  @media screen and (max-width:428px){
    padding:10px 2px;
  }
`

const Row = styled.div`
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  margin:0px 0px;
  div{
    color:white;
    width:50%;
  }
  @media screen and (max-width:768px){
    margin:10px 0px;
    display:block;
    div{
      width:100%;
    }
  }
`

const ImageContainer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    img{
      width:100%;
      transform: scale(0.8);
      box-shadow: 0px 0px 102px 20px rgba(77,75,50,0.72);
      border: 2px solid rgba(77,75,50,0.72);
      transition: all 0.9s ease-in-out;
      &:hover{
        transform: scale(0.9);
        border-radius:10px;
      }
      @media screen and (max-width:500px){
        
      }
    }
`

const TextContainer = styled.div`
    padding:10px;
    background:transparent;
    width:100%;
    h4{
      background:transparent;
      padding:30px;
      color:white;
      font-size:20px;
      font-weight:400;
      line-height: 1.9rem;
    }
    button {
      background-color: var(--border);
      padding: 10px 20px;
      border-radius: 10px;
      outline: none;
      border: none;
      text-transform: uppercase;
      width: 100%;
      transition: all 0.9s ease-in-out;
      &:hover{
        scale: 0.9;
      }
    }
    @media screen and (max-width:768px){
      h4{
        text-align:center;
        line-height: 1.5rem;
      }
    }
    @media screen and (max-width:500px){
      h4{
        padding:10px;
        letter-spacing:1.2px;
        text-align:start;
        font-size:16px;
      }
    }
`
const MyWorkContanier = ({image, showButton, imageAlt, title, desc, imageLast, url='', onClick, resourcesFlag=false}) => {
    return(
      <MyWorkContainer className={`overflowXHidden`} onClick={url && url.length > 10 ? ()=>window.open(url, '_blank') : ()=>true}>
        {/* ${imageLast ? 'slide-in-left' : 'slide-in-right'} */}
        <Row className="animated slideInUp">
          {!imageLast &&
            <ImageContainer>
              <img src={image} alt={imageAlt} />
            </ImageContainer>
          }
          <TextContainer>
            <Title fontSize='35px'>{title}</Title>
            <h4>{desc}</h4>
            {showButton &&
              <button onClick={()=>onClick()}>Buy Now</button>
            }
          </TextContainer>
          {imageLast &&
          <ImageContainer>
            <img src={image} alt={imageAlt} />
          </ImageContainer>
          }
        </Row>
      </MyWorkContainer>
    )
  }
export default MyWorkContanier